import React from 'react';
import { motion } from 'framer-motion';
import { BookOpen, CheckSquare, Brain, MessageCircle, Lightbulb } from 'lucide-react';
export function WhatIncludes() {
  const features = [{
    icon: BookOpen,
    text: 'Capítulos por "pantallas"'
  }, {
    icon: CheckSquare,
    text: 'Checklists y ejercicios breves de aplicación inmediata'
  }, {
    icon: Brain,
    text: 'Marcos mentales para desactivar la culpa y el resentimiento'
  }, {
    icon: MessageCircle,
    text: 'Guías de conversación (sin drama, sin pleito innecesario)'
  }, {
    icon: Lightbulb,
    text: 'Estrategias para recuperar energía esta misma semana'
  }];
  return <section className="py-14 px-6 bg-cream" data-id="element-195">
      <div className="max-w-5xl mx-auto" data-id="element-196">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 items-center" data-id="element-197">
          <motion.div initial={{
          opacity: 0,
          scale: 0.9
        }} whileInView={{
          opacity: 1,
          scale: 1
        }} viewport={{
          once: true
        }} className="relative" data-id="element-198">
            <div className="absolute inset-0 bg-terracotta/10 transform rotate-3 rounded-2xl" data-id="element-199"></div>
            <img src="https://cdn.magicpatterns.com/uploads/ofULURPzh8Qh9mHXzYVhsR/Mockup_Cuidado_de_Padres_Envejecidos.png" alt="Mockup del libro" className="relative rounded-2xl shadow-xl w-full max-w-sm mx-auto" data-id="element-200" />
          </motion.div>

          <div className="space-y-6" data-id="element-201">
            <motion.div initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} data-id="element-202">
              <h2 className="text-3xl md:text-4xl font-serif font-bold text-navy mb-4" data-id="element-203">
                Qué incluye el PDF
              </h2>
              <p className="text-lg text-navy/80 mb-4" data-id="element-204">
                "Cuando Todo Recae Sobre Ti" está diseñado para leerse rápido y
                aplicarse en la vida real, entre citas médicas y llamadas de
                emergencia.
              </p>
            </motion.div>

            <div className="space-y-4" data-id="element-205">
              {features.map((feature, index) => <motion.div key={index} initial={{
              opacity: 0,
              x: 20
            }} whileInView={{
              opacity: 1,
              x: 0
            }} viewport={{
              once: true
            }} transition={{
              delay: index * 0.1
            }} className="flex items-center gap-4" data-id="element-206">
                  <feature.icon className="w-6 h-6 text-terracotta shrink-0" data-id="element-207" />
                  <span className="text-navy font-medium" data-id="element-208">{feature.text}</span>
                </motion.div>)}
            </div>
          </div>
        </div>
      </div>
    </section>;
}